import BaseSidebar from '../../../shared/components/layouts/BaseSidebar';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUserData, selectUser } from '../../../../app/store/slices/userSlice';
import React, { useEffect, } from 'react';

const SettingsSidebar = ({ onSectionChange, activeSection }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        await dispatch(fetchUserData()).unwrap();
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      }
    };

    fetchUser();
  }, [dispatch]);
  const settingsMenu = user?.role === 'admin'
    ? [
      'Manage Password',
      'Terms & Conditions',
      'Privacy Policy',
    ]
    : [
      'Manage Canvas',
      'Manage Group',
      ...(user?.role !== 'kid'
        ? [
          'Manage payments & subscription plan',
          'Manage Password',
          'Delete',
        ]
        : []),
      'Terms & Conditions',
      'Privacy Policy',
    ];

  return (
    <BaseSidebar
      items={settingsMenu}
      onSectionChange={onSectionChange}
      activeSection={activeSection}
      transformItemText={(text) => text.toLowerCase().replace(/\s+/g, '-')}
    />
  );
};

export default SettingsSidebar;
